import { render } from "./MainBreadcrumbs.vue?vue&type=template&id=124ba7f9"
import script from "./MainBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./MainBreadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__